/* globals google */
"use strict";
var debounce = require("lodash/debounce");
var removeHTMLTags = require("./../util/htmlTagRemover");
var sessionToken = new google.maps.places.AutocompleteSessionToken();

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf("?") !== -1 ? "&" : "?") + Object.keys(params).map(function (key) {
        return key + "=" + encodeURIComponent(params[key]);
    }).join("&");

    return newUrl;
}

/**
 * Uses google maps api to render a map
 */
let allMarkers = [];
var map;
var infowindow = new google.maps.InfoWindow();
function maps(latValue, longValue) {
    var $mapContainer = $(".map-canvas");
    var defaultLat = latValue || $mapContainer.data("defaultlat");
    var defaultLong = longValue || $mapContainer.data("defaultlong");
    var input = document.getElementById("store-postal-code");

    var mapZoom = $(".map-canvas").attr("data-map-zoom");
    mapZoom = parseFloat(mapZoom);
    // Init U.S. Map in the center of the viewport
    var latlng = new google.maps.LatLng(defaultLat, defaultLong);
    var mapOptions = {
        scrollwheel: false,
        zoom: mapZoom,
        center: latlng
    };

    map = new google.maps.Map($mapContainer[0], mapOptions);
    var mapdiv = $(".map-canvas").attr("data-locations");

    mapdiv = mapdiv ? JSON.parse(mapdiv) : {};

    var bounds = new google.maps.LatLngBounds();

    var autocomplete = new google.maps.places.Autocomplete(input);

    autocomplete.bindTo("bounds", map);

    Object.keys(mapdiv).forEach(function (key) {
        var item = mapdiv[key];
        var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
        var marker = new google.maps.Marker({
            position: storeLocation,
            map: map,
            title: item.name,
            icon: {
                url:"data:image/svg+xml;charset=utf-8," + encodeURIComponent("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 43'><path d='M16 0c8.84 0 16 5.28 16 15.06q0 9.78-16 27.61Q0 24.84 0 15.06C0 5.28 7.16 0 16 0z' data-name='Calque 1'/><path d='M26.91 10.18h-7.54A4.81 4.81 0 0016 11.51l-3 2.82h11.85zM11 16.26l-5.91 5.59H19a3.15 3.15 0 002.82-1.44l2.06-4.15z' fill='#fff' data-name='Calque 2'/></svg>"),
                scaledSize: new google.maps.Size(47, 47)
            },
            id: item.id,
            html: item.infoWindowHtml
        });

        allMarkers.push(marker);

        marker.addListener("click", function () {
            infowindow.setOptions({
                content: item.infoWindowHtml
            });

            infowindow.open(map, marker);

            let results = $(".m-store-locator-result");
            let resultsWrapper = $(".m-store-locator-results-wrapper .results");

            results.each(function () {
                var $this = $(this);

                let $storeDetail = $this.find(".store-details");
                let name = $storeDetail.data("store-id");

                if (name === item.id) {
                    resultsWrapper.prepend($this);
                    resultsWrapper.animate({ scrollTop: 0 }, "slow");
                }
            });

            window.scroll({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
        });

        // Create a minimum bound based on a set of storeLocations
        bounds.extend(marker.position);
    });
    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (mapdiv && mapdiv.length !== 0) {
        map.fitBounds(bounds);
    }

    autocomplete.addListener("place_changed", function () {
        var place = autocomplete.getPlace();
        if (place.geometry) {
            var lat = document.getElementById("lat");
            var long = document.getElementById("long");
            lat.value = place.geometry ? place.geometry.location.lat() : null;
            long.value = place.geometry ? place.geometry.location.lng(): null;
        }
    });

    $mapContainer.height(window.innerHeight - $(".l-header").height() + 45);

}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data, lat, long) {
    var $resultsDiv = $(".results");
    var $mapDiv = $(".map-canvas");
    var hasResults = data ? data.stores.length > 0 : null;
    var $input = $("#store-postal-code");
    var $noresults = $(".js-store-locator-no-results");
    var $noresultsGeolocation = $(".js-store-locator-no-results-geolocation");
    var $searchValue = $(".search-value");
    if (lat && long) {
        $noresults.addClass("d-none");
        if (!hasResults) {
            $noresultsGeolocation.removeClass("d-none");
        } else {
            $noresultsGeolocation.addClass("d-none");
        }
    } else {
        if (!hasResults) {
            $searchValue.html($input.val());
            $noresults.removeClass("d-none");
        } else {
            $noresults.addClass("d-none");
        }
        $noresultsGeolocation.addClass("d-none");
    }

    if (data) {
        $resultsDiv.empty()
            .attr("data-has-results", hasResults)
            .data("radius", data.radius)
            .data("search-key", data.searchKey);

        $mapDiv.attr("data-locations", data.locations);
        allMarkers = [];
        if ($mapDiv.data("has-google-api")) {
            maps(lat, long);
        } else {
            $(".store-locator-no-apiKey").show();
        }

        if (data.storesResultsHtml) {
            $resultsDiv.append(data.storesResultsHtml);
        }
        initMarkerPopup();
    } else {
        $resultsDiv.empty();
        allMarkers = [];
        $mapDiv.attr("data-locations", "[]");
        maps();
    }

    if (hasResults) {
        initStickyMap();
    }
}

/**
 * Renders the marker popup when the store pin icon is clicked
 */

const initMarkerPopup = () => {
    let mapIcon = document.querySelectorAll(".map-icon");
    var isFirst = true;
    mapIcon.forEach((el) => {
        let id = el.nextElementSibling.querySelector(".store-details").dataset.storeId;
        let marker = allMarkers.find(m => m.id === id);
        if (marker) {
            el.addEventListener("click", function () {
                infowindow.setOptions({
                    content: marker.html
                });

                infowindow.open(map, marker);
            });

            if (isFirst) {
                infowindow.setOptions({
                    content: marker.html
                });

                infowindow.open(map, marker);
            }
            isFirst = false;
        }
    });
};

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element) {
    var dialog = element.closest(".in-store-inventory-dialog");
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    var input = document.getElementById("store-postal-code");
    var $form = element.closest(".store-locator");
    input.value = removeHTMLTags(input.value); // removes html tags in the string

    if (!input.value) {
        input.classList.add("is-invalid");
        $form.find(".error-feedback").removeClass("d-none");
        $form.addClass("validation-in-place");
        $(".js-store-locator-no-results-geolocation").addClass("d-none");
    } else {
        input.classList.remove("is-invalid");
        $form.find(".error-feedback").addClass("d-none");
        $form.removeClass("validation-in-place");
        spinner.start();

        var radius = $(".results").data("radius");
        var url = $form.attr("action");
        var urlParams = { radius: radius };
        var $lat = $form.find("#lat");
        var $long = $form.find("#long");
        var payload = {lat: $lat.val(), long : $long.val()};
        url = appendToUrl(url, urlParams);
        var storeFilters = $(".js-store-filters");
        var filters = {};

        storeFilters.each(function () {
            var $storeFilter = $(this);
            var filterID = $storeFilter.data("filterid");
            var $filters = $storeFilter.find("input[type='checkbox']");
            var $checkedFilters = $storeFilter.find("input[type='checkbox']:checked");

            if ($filters.length != $checkedFilters.length) {
                filters[filterID] = [];
                $checkedFilters.each(function () {
                    filters[filterID].push($(this).val());
                });
            }
        });

        url = appendToUrl(url, { filters: JSON.stringify(filters)});

        if ($lat.val() === "" || $long.val() === "") {
            var autocompleteService = new google.maps.places.AutocompleteService();
            var displaySuggestions = function (predictions) {
                if (predictions) {
                    var placeService = new google.maps.places.PlacesService(input);
                    var request = {
                        placeId: predictions[0]["place_id"],
                        fields: ["geometry"],
                        sessionToken: sessionToken
                    };

                    placeService.getDetails(request, function (place) {
                        if (place.geometry) {
                            payload = {lat: place.geometry.location.lat(), long : place.geometry.location.lng()};
                            searchStores(url, $form, payload, spinner, $lat, $long);
                        }
                    });
                } else {
                    updateStoresResults();
                    spinner.stop();
                }
            };

            autocompleteService.getPlacePredictions({
                input: input.value,
                sessionToken: sessionToken
            }, displaySuggestions);
        } else {
            searchStores(url, $form, payload, spinner, $lat, $long);
        }
    }

    return false;
}

/**
 * Search for stores with the given parameters
 */
function searchStores(url, form, payload, spinner, lat, long) {
    $.ajax({
        url: url,
        type: form.attr("method"),
        data: payload,
        dataType: "json",
        success: function (data) {
            spinner.stop();
            updateStoresResults(data);
            $(".select-store").prop("disabled", true);
            lat.val("");
            long.val("");
        }
    });
}

/**
 * Initialize the sticky map when there are results on store search
 */

function initStickyMap() {
    let $window = $(window);

    if ($window.data("stickMapInitialized")) {
        return;
    }

    let $header = $(".l-header");
    let $map = $(".map-canvas-wrapper");
    let $stickyContainer = $map.wrap("<div>").parent().addClass("m-store-locator__sticky-wrapper");

    let stickyPosition = $stickyContainer[0].getBoundingClientRect();
    let left = stickyPosition.left;
    let width = stickyPosition.width;
    let $mapWrapper = $map.closest(".m-store-locator-map");
    let top = $header.hasClass("fixed-top") ? $header.height() : 0;
    let height = $map.height();
    let bottom = top + $map.height() + $header.height();
    let mapWrapperEl = $mapWrapper[0];

    function reinitStickyMap() {
        $stickyContainer = $map.parent(".m-store-locator__sticky-wrapper");
        if (!$stickyContainer.length) {
            $stickyContainer = $map.wrap("<div>").parent().addClass("m-store-locator__sticky-wrapper");
        }
        $mapWrapper = $map.closest(".m-store-locator__map-wrapper");
        top = $header.height();
        height = $map.height();
        bottom = top + $map.height();
        mapWrapperEl = $mapWrapper[0];
    }

    function recalcMapSize() {
        height = $map.height();
        stickyPosition = $stickyContainer[0].getBoundingClientRect();
        left = stickyPosition.left;
        width = stickyPosition.width;
        bottom = top + height;
        recalcMapTop();
    }

    function recalcMapTop() {
        top = $header.height();
        bottom = top + height;
    }

    function recalcMapPosition() {
        let css = {
            position: "relative",
            top: "",
            left: "",
            bottom: "",
            width: ""
        };

        let wrapperPositon = mapWrapperEl.getBoundingClientRect();
        if (wrapperPositon.top <= top) {
            if (wrapperPositon.bottom > bottom - 70) {
                css.position = "fixed";
                css.top = $header.height();
                css.left = left;
                css.width = width;
            } else {
                css.position = "absolute";
                css.bottom = 0;
                css.width = width;
            }
        }
        $map.css(css);
    }

    $window.on("resize", function () {
        recalcMapSize();
        recalcMapPosition();
    });

    window.addEventListener("scroll", debounce(function () {
        recalcMapPosition();
    }), 120);

    $window.on("reinit:stickymap", reinitStickyMap);

    recalcMapPosition();

    $window.data("stickMapInitialized", true);
}

module.exports = {
    init: function () {
        if ($(".map-canvas").data("has-google-api")) {
            maps();
        } else {
            $(".store-locator-no-apiKey").show();
        }
    },

    detectLocation: function () {
        // clicking on detect location.
        $(".detect-location").on("click", function () {
            $.spinner().start();
            if (!navigator.geolocation) {
                $.spinner().stop();
                return;
            }
            const input = document.getElementById("store-postal-code");
            input.classList.remove("is-invalid");
            input.classList.add("search-field");
            document.querySelector(".error-feedback").classList.add("d-none");
            navigator.geolocation.getCurrentPosition(function (position) {
                var $detectLocationButton = $(".detect-location");
                var url = $detectLocationButton.data("action");
                var radius = $(".results").data("radius");
                var urlParams = {
                    showMap: true,
                    radius: radius,
                    lat: position.coords.latitude,
                    long: position.coords.longitude
                };

                url = appendToUrl(url, urlParams);

                var storeFilters = $(".js-store-filters");
                var filters = {};

                storeFilters.each(function () {
                    var $storeFilter = $(this);
                    var filterID = $(this).data("filterid");
                    var $filters = $storeFilter.find("input[type='checkbox']");
                    var $checkedFilters = $storeFilter.find("input[type='checkbox']:checked");

                    if ($filters.length != $checkedFilters.length) {
                        filters[filterID] = [];
                        $checkedFilters.each(function () {
                            filters[filterID].push($(this).val());
                        });
                    }
                });

                url = appendToUrl(url, { filters: JSON.stringify(filters)});

                $.ajax({
                    url: url,
                    type: "get",
                    dataType: "json",
                    success: function (data) {
                        $.spinner().stop();
                        updateStoresResults(data, urlParams.lat, urlParams.long);
                        $(".select-store").prop("disabled", true);
                    }
                });
            },
            function (error) {
                if (error.code == error.PERMISSION_DENIED) {
                    $.spinner().stop();
                }
            }, {enableHighAccuracy: false});
        });
    },

    search: function () {
        $(".store-locator-container form.store-locator").submit(function (e) {
            e.preventDefault();
            search($(this));
        });
        $(".store-locator-container .storelocator-search-button[type=\"button\"]").click(function (e) {
            e.preventDefault();
            search($(this));
        });
    },

    changeRadius: function () {
        $(".store-locator-container .radius").change(function () {
            var $this = $(this);
            var radius = $this.val();
            var searchKeys = $(".results").data("search-key");
            var url = $this.data("action-url");
            var urlParams = {};

            if (searchKeys.postalCode) {
                urlParams = {
                    radius: radius,
                    postalCode: searchKeys.postalCode
                };
            } else if (searchKeys.lat && searchKeys.long) {
                urlParams = {
                    radius: radius,
                    lat: searchKeys.lat,
                    long: searchKeys.long
                };
            }

            url = appendToUrl(url, urlParams);

            var dialog = $this.closest(".in-store-inventory-dialog");
            var spinner = dialog.length ? dialog.spinner() : $.spinner();

            spinner.start();
            $.ajax({
                url: url,
                type: "get",
                dataType: "json",
                success: function (data) {
                    spinner.stop();
                    updateStoresResults(data);
                    $(".select-store").prop("disabled", true);
                }
            });
        });
    },
    selectStore: function () {
        $(".store-locator-container").on("click", ".select-store", (function (e) {
            e.preventDefault();
            var selectedStore = $(":checked", ".results-card .results");
            var data = {
                storeID: selectedStore.val(),
                searchRadius: $("#radius").val(),
                searchPostalCode: $(".results").data("search-key").postalCode,
                storeDetailsHtml: selectedStore.siblings("label").find(".store-details").html(),
                event: e
            };

            $("body").trigger("store:selected", data);
        }));
    },
    updateSelectStoreButton: function () {
        $("body").on("change", ".select-store-input", (function () {
            $(".select-store").prop("disabled", false);
        }));
    }
};
